export default "__VITE_ASSET__BLjVIXnO__"